// Constant Data that related to Customer Cart Voucher Rule

export const CART_ATTRIBUTE = {
  TL_PAYMENT_METHOD_ID  : 'tl_payment_method_id',
  TL_SHIPMENT_METHOD_ID : 'tl_shipment_method_id',
  TL_PROVINCE_ID        : 'tl_province_id',
  TL_CITY_ID            : 'tl_city_id',
  ITEM_PRICE_TOTAL      : 'item_price_total',
  ITEM_QUANTITY         : 'item_quantity',
  SUB_TOTAL             : 'sub_total'
}

export const DISCOUNT_TYPE = {
  PERCENT    : 'percent',
  FIXED      : 'fixed',
  CART_FIXED : 'cart_fixed'
}

export const SHIPMENT_DISCOUNT_TYPE = {
  PERCENTAGE : 'percentage',
  ABSOLUTE   : 'absolute'
}

export const ITEM_DISCOUNT_TYPE = {
  PERCENTAGE : 'percentage',
  ABSOLUTE   : 'absolute'
}

export const DISCOUNT_FOR = {
  ITEM     : 'item',
  SHIPMENT : 'shipment'
}

export const VOUCHER_CATEGORIES = {
  BRAND_MARKETING   : 'brand_marketing',
  DIGITAL_MARKETING : 'digital_marketing',
  MARKETING         : 'marketing',
  ONLINE_CAMPAIGN   : 'online_campaign',
  OTP               : 'otp',
  PSA               : 'psa',
  REFUND            : 'refund',
  OTHERS            : 'others'
}